import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {StocksFilter} from "app/stocks/models/stocks-filter";
import {StocksFiltersState, StocksFiltersStateGUID} from "app/stocks/models/stocks-filters-state";
import {ClearSelected, ClearSelectedGUID} from "app/stocks/models/clear-selected";
import {SelectedFilter, SelectedFilterGUID} from "app/stocks/models/selected-filter";
import {Focus, FocusGUID} from "app/stocks/models/focus";
import {BlockFilter, BlockFilterGUID} from "app/stocks/models/block-filter";
import {ValidateData} from "app/stocks/models/validate-data";
import {AdditionalFilterData, AdditionalFilterDataGUID} from "../models/additional-filter-data";
import {StocksPreset} from "../models/stocks-preset";
import {StocksFilterGUID} from "../models/stocks-filter";
import {StocksHelper} from "../models/stocks-helper";
import {Observable} from "rxjs/Observable";
import {CodeName} from "../models/code-name";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {HttpBase} from "../../services/http-base.service";
import {InfoPanelGUID} from "../models/info-panel";
import {FilterControlSettings} from "../models/filter-control-settings";


@Injectable()
export class StocksFilterService extends HttpBase{
    constructor(http: HttpClient, router: Router, translateService: TranslateService){
        super(http, router, translateService);
        this.controller = 'stocksfilter';
    };

    //# main filter
    private stocksFilterSource = new BehaviorSubject([]);
    stocksFilterCurrent = this.stocksFilterSource.asObservable();

    //# main filter state (need to update additional data or not)
    public stocksFiltersStateSource = new BehaviorSubject([]);
    stocksFiltersStateCurrent = this.stocksFiltersStateSource.asObservable();

    private fillFilterSource = new BehaviorSubject(null);
    fillFilterCurrent = this.fillFilterSource.asObservable();

    private fillFilterAdditionalDataSource = new BehaviorSubject(null);
    fillFilterAdditionalDataCurrent = this.fillFilterAdditionalDataSource.asObservable();

    private getAdditionalDataSource = new BehaviorSubject(null);
    getAdditionalDataCurrent = this.getAdditionalDataSource.asObservable();

    private filtersScrollSource = new BehaviorSubject(null);
    filtersScrollCurrent = this.filtersScrollSource.asObservable();

    private selectedFiltersSource = new BehaviorSubject(null);
    selectedFiltersCurrent = this.selectedFiltersSource.asObservable();

    private selectedFiltersStorageSource = new BehaviorSubject(null);
    selectedFiltersStorageCurrent = this.selectedFiltersStorageSource.asObservable();

    private updateSelectedFiltersSource = new BehaviorSubject(null);
    updateSelectedFiltersCurrent = this.updateSelectedFiltersSource.asObservable();

    private updateSelectedFiltersDataSource = new BehaviorSubject(null);
    updateSelectedFiltersDataCurrent = this.updateSelectedFiltersDataSource.asObservable();

    private clearSelectedFilterSource = new BehaviorSubject(null);
    clearSelectedFilterCurrent = this.clearSelectedFilterSource.asObservable();

    private hideGridSelectedFiltersSource = new BehaviorSubject(null);
    hideGridSelectedFiltersCurrent = this.hideGridSelectedFiltersSource.asObservable();

    private hideFilterGridSource = new BehaviorSubject(null);
    hideFilterGridCurrent = this.hideFilterGridSource.asObservable();

    private loadDataFilterSource = new BehaviorSubject(null);
    loadDataFilterCurrent = this.loadDataFilterSource.asObservable();

    private goToNextFilterSource = new BehaviorSubject(null);
    goToNextFilterCurrent = this.goToNextFilterSource.asObservable();

    private goToNextFilter2Source = new BehaviorSubject(null);
    goToNextFilter2Current = this.goToNextFilter2Source.asObservable();

    private blockFilterSource = new BehaviorSubject(null);
    blockFilterCurrent = this.blockFilterSource.asObservable();

    private updateValidateDataSource = new BehaviorSubject(null);
    updateValidateDataCurrent = this.updateValidateDataSource.asObservable();

    private clearFilterSource = new BehaviorSubject(null);
    clearFilterCurrent = this.clearFilterSource.asObservable();

    private showFiltersSource = new BehaviorSubject(null);
    showFiltersCurrent = this.showFiltersSource.asObservable();

    private stocksDataSource = new BehaviorSubject(null);
    stocksDataCurrent = this.stocksDataSource.asObservable();

    private updateColumnsSource = new BehaviorSubject(null);
    updateColumnsCurrent = this.updateColumnsSource.asObservable();

    private updateSummarySource = new BehaviorSubject(null);
    updateSummaryCurrent = this.updateSummarySource.asObservable();

    private getColumnsSource = new BehaviorSubject(false);
    getColumnsCurrent = this.getColumnsSource.asObservable();

    private deletePresetSource = new BehaviorSubject('');
    deletePresetCurrent = this.deletePresetSource.asObservable();

    private addPresetSource = new BehaviorSubject(null);
    addPresetCurrent = this.addPresetSource.asObservable();

    private editPresetSource = new BehaviorSubject(null);
    editPresetCurrent = this.editPresetSource.asObservable();

    private changePresetSource = new BehaviorSubject(null);
    changePresetCurrent = this.changePresetSource.asObservable();

    private updateHotKeysSource = new BehaviorSubject(null);
    updateHotKeysCurrent = this.updateHotKeysSource.asObservable();

    private changeHotKeysSource = new BehaviorSubject(null);
    changeHotKeysCurrent = this.changeHotKeysSource.asObservable();

    private clearGrpAndAgrSource = new BehaviorSubject('');
    clearGrpAndAgrCurrent = this.clearGrpAndAgrSource.asObservable();

    private updateItemIdInfoChartSource = new BehaviorSubject(null);
    updateItemIdInfoChartCurrent = this.updateItemIdInfoChartSource.asObservable();

    private infoAutoUpdateSource = new BehaviorSubject(null);
    infoAutoUpdateCurrent = this.infoAutoUpdateSource.asObservable();

    private changeOuterViewSource = new BehaviorSubject(null);
    changeOuterViewCurrent = this.changeOuterViewSource.asObservable();

    private freezeColumnFromMenuSource = new BehaviorSubject(null);
    freezeColumnFromMenuCurrent = this.freezeColumnFromMenuSource.asObservable();

    private bufferZoneFilterSource = new BehaviorSubject(null);
    bufferZoneFilterCurrent = this.bufferZoneFilterSource.asObservable();

    private goodInfoStorageSource = new BehaviorSubject(null);
    goodInfoStorageCurrent = this.goodInfoStorageSource.asObservable();

    private helper: StocksHelper = new StocksHelper();

    // private updateMenuPopperSource = new BehaviorSubject('');
    // updateMenuPopperCurrent = this.updateMenuPopperSource.asObservable();



    //# clear data in service
    clearService = (): void => {
        this.updateItemIdInfoChartSource.next(null);
        this.clearSelectedFilterSource.next(null);
        this.updateSelectedFiltersDataSource.next(null);
        this.updateSelectedFiltersSource.next(null);
        this.selectedFiltersSource.next(null);
        this.selectedFiltersStorageSource.next(null);
        this.getAdditionalDataSource.next(null);
        this.fillFilterAdditionalDataSource.next(null);
        this.fillFilterSource.next(null);
        this.stocksFilterSource.next([]);
        this.stocksFiltersStateSource.next([]);
        this.clearGrpAndAgrSource.next(null);
        this.changeHotKeysSource.next(null);
        this.updateHotKeysSource.next(null);
        this.changePresetSource.next(null);
        this.editPresetSource.next(null);
        this.goodInfoStorageSource.next(null);
        // console.log('clearService')
    }


    setFilter = (data: StocksFilterGUID): void =>{
        this.helper.updateArrGUID(this.stocksFilterSource, data);
    };

    getFilter = (GUID: string): StocksFilterGUID => {
        return this.helper.getGUIDObj(this.stocksFilterSource.getValue(), GUID) ;
    };


    setFiltersState = (filtersState: StocksFiltersStateGUID): void =>{
        // let filtersStateArr: StocksFiltersStateGUID[] = this.stocksFiltersStateSource.getValue();
        this.helper.updateArrGUID(this.stocksFiltersStateSource, filtersState);
        // let arr2 = this.helper.updateArrGUID2(filtersStateArr, filtersState);
        // this.stocksFiltersStateSource.next(arr2)
    };

    /*getFiltersState = () =>{
        return this.stocksFiltersStateCurrent
    };*/


    updateFiltersState = (data: {GUID: string, prop: string}): void =>{
        // console.log(data, 'updateFiltersState');
        let filtersStateArr: StocksFiltersStateGUID[] = this.stocksFiltersStateSource.getValue(),
            filtersState:StocksFiltersStateGUID = filtersStateArr.find(item => item.GUID === data.GUID);
        if (filtersState){
            for (let property in filtersState.stocksFiltersState) {
                filtersState.stocksFiltersState[property] = data.prop === property;
            }
        }
        // console.log(filtersStateArr, 'filtersStateArr')
        // console.log(filtersState, 'filtersState')
        // let arr2 = this.helper.updateArrGUID2(filtersStateArr, filtersState);
        // this.stocksFiltersStateSource.next(arr2);
        this.helper.updateArrGUID(this.stocksFiltersStateSource, filtersState);
    };


    setFillFilter = (data: {GUID: string, fillFilter: boolean}): void =>{
        this.fillFilterSource.next(data);
    };


    setFillFilterAdditionalData = (data: {GUID: string, additionalDataObj: any}): void =>{
        // this.helper.updateArrGUID(this.fillFilterAdditionalDataSource, data);
        this.fillFilterAdditionalDataSource.next(data)
    };

    setFiltersScroll = (scrollPosition: number): void =>{
        this.filtersScrollSource.next(scrollPosition);
    };


    setSelectedFilters = (selectedFilters: SelectedFilterGUID): void =>{
        // this.helper.updateArrGUID(this.selectedFiltersSource, selectedFilters);
        this.selectedFiltersSource.next(selectedFilters)
    };

    setSelectedStorageFilters = (selectedFilters: SelectedFilterGUID): void =>{
        if (!selectedFilters){
            return;
        }
        // this.helper.updateArrGUID(this.selectedFiltersSource, selectedFilters);
        let selectedFiltersArr: SelectedFilterGUID[] = this.selectedFiltersStorageSource.getValue();
        selectedFiltersArr
            ? this.helper.remFromArr(selectedFiltersArr, 'GUID', selectedFilters.GUID)
            : selectedFiltersArr = [];

        selectedFiltersArr.push(selectedFilters);
        this.selectedFiltersStorageSource.next(selectedFiltersArr);
    };

    getSelectedStorageFilters = (GUID: string): SelectedFilterGUID => {
        if (!GUID){
            return;
        }

        let selectedFiltersArr: SelectedFilterGUID[] = this.selectedFiltersStorageSource.getValue();
        return selectedFiltersArr.find(sf => sf.GUID === GUID);
    };

    setUpdateSelectedFilters = (additionalData: AdditionalFilterDataGUID): void =>{
        // this.helper.updateArrGUID(this.updateSelectedFiltersSource, additionalData);
        this.updateSelectedFiltersSource.next(additionalData)
    };

    setUpdateSelectedDataFilters = (selectedFilters: SelectedFilterGUID): void =>{
        this.setSelectedStorageFilters(selectedFilters);
        // this.helper.updateArrGUID(this.updateSelectedFiltersDataSource, selectedFilters);
        this.updateSelectedFiltersDataSource.next(selectedFilters)
    };

    setGetAdditionalData = (data: {GUID: string, param: string, filter: StocksFilter}): void =>{
        this.getAdditionalDataSource.next(data);
    };

    setClearSelectedFilter = (selectedFilter: ClearSelectedGUID): void =>{
        // this.helper.updateArrGUID(this.clearSelectedFilterSource, selectedFilter);
        this.clearSelectedFilterSource.next(selectedFilter)
    };

    setHideGridSelectedFilter = (show: {GUID: string, show: boolean}): void =>{
        this.hideGridSelectedFiltersSource.next(show);
    };

    setHideFilterGrid = (param: {GUID: string, param: string}): void =>{
        this.hideFilterGridSource.next(param);
    };

    setLoadDataFilter = (param: {GUID: string, param: string}): void =>{
        this.loadDataFilterSource.next(param);
    };

    setGoToNextFilter = (param: {GUID: string, param: string}): void =>{
        this.goToNextFilterSource.next(param);
    };

    setGoToNextFilter2 = (focus: FocusGUID): void =>{
        // this.helper.updateArrGUID(this.goToNextFilter2Source, focus);
        this.goToNextFilter2Source.next(focus);
    };


    setBlockFilter = (block: BlockFilterGUID): void =>{
        // this.helper.updateArrGUID(this.blockFilterSource, block);
        this.blockFilterSource.next(block)
    };

    setUpdateValidateData = (validateObj: {GUID: string, param: string, data: ValidateData[]}): void =>{
        // this.helper.updateArrGUID(this.updateValidateDataSource, validateObj);
        this.updateValidateDataSource.next(validateObj)

    };

    setClearFilter = (data: { GUID: string, command: string}): void =>{
        this.clearFilterSource.next(data);
    };

    setShowFilters = (data: { GUID: string, show: boolean}): void =>{
        this.showFiltersSource.next(data);
    };

    setStocksData = (data: {GUID: string, command: string}): void =>{
        this.stocksDataSource.next(data);
    };

    setUpdateColumnsData = (data: { command: string, grid: string, columnId: string, addColumnId: string }): void =>{
        this.updateColumnsSource.next(data);
    };

    setUpdateSummaryData = (data: { command: string, json: string | number[]}): void =>{
        this.updateSummarySource.next(data);
    };

    setGetColumns = (emit: boolean): void =>{
        this.getColumnsSource.next(emit);
    };

    setDeletePreset = (presetName: string): void =>{
        this.deletePresetSource.next(presetName);
        this.deletePresetSource.next(null);
    };

    setAddPreset = (preset: StocksPreset): void =>{
        this.addPresetSource.next(preset);
        this.addPresetSource.next(null);
    };

    setEditPreset = (data: {command: string, presetGuidName: string} ): void =>{
        this.editPresetSource.next(data);
    };

    setChangePreset = (data: {command: string, presetGuidName: string} ): void =>{
        this.changePresetSource.next(data);
    };

    setUpdateHotKeys = (data: {presets: StocksPreset[], activePresetGuidName: string}): void =>{
        this.updateHotKeysSource.next(data);
    };

    setChangeHotKeys = (data: {command: string, presetGuidName: string, preset: StocksPreset}): void =>{
        this.changeHotKeysSource.next(data);
    };

    setClearGrpAndAgr = (command: string): void =>{
        this.clearGrpAndAgrSource.next(command);
    };

    /*getFilter = () =>{
        return this.stocksFilterCurrent
    };*/

    setUpdateItemIdInfoChart = (itemId: number): void =>{
        this.updateItemIdInfoChartSource.next(itemId);
    };



    public controller: string;

    //# get data for codename filter
    GetDataForCodeNameFilter = (filterName: string, filter: StocksFilter): Observable<CodeName[]> =>{
        // console.log(filterName, filter, this.controller, 'GetDataForCodeNameFilter')
        return this.post<CodeName[]>(`/api/${this.controller}/getmaindata`, {filter, filterName}).map(data =>{
            if (data && data.length)
                data = data.map( (p, i) => new CodeName(
                    i + 1,
                    false,
                    p.code,
                    p.name
                ));
            return data;
        });
    };

    //# get additional data (data restrictions for all filters)
    GetDataAdditionalDataFilter = (filterName: string, filter: StocksFilter): Observable<AdditionalFilterData[]> =>{
        return this.post<AdditionalFilterData[]>(`/api/${this.controller}/getadditionaldata`, {filter, filterName}).map(data =>{
            if (data && data.length){
                if (data.length === 1 && data[0] === null){
                    data = [];
                } else if (data) {
                    data = data.filter(d => d);
                    data.map( r => new AdditionalFilterData(
                        r.name.toLowerCase(),
                        r.filterData,
                        r.allItemsQuantity
                    ));
                }
            }

            return data;
        });
    };

    //# set value to auto-update
    updateDataInFilterForTranslate = (filter: StocksFilter, additionalData: AdditionalFilterData[], filterSettings: FilterControlSettings[]): void =>{
        additionalData.forEach(ad => {
            filterSettings.forEach(fs => {
                if (ad.name === fs.name && fs.translate === 1){
                    filter[fs.name + 'name'] = []
                }
            })
        })
    };

    //# set value to auto-update
    setAutoUpdate = (autoUpdate: boolean): void =>{
        this.infoAutoUpdateSource.next(autoUpdate);
    };

    //# get needed value for auto-update
    getAutoUpdate = (): boolean =>{
        return this.infoAutoUpdateSource.getValue();
    };

    //# get value to auto-update
    setOuterView = (changeOuterView: boolean): void =>{
        this.changeOuterViewSource.next(changeOuterView);
    };

    //# set value to auto-update
    setViewFreeze = (val: number): void =>{
        this.freezeColumnFromMenuSource.next(val);
    };

    //# get needed value for auto-update
    getOuterView = (): boolean =>{
        return this.changeOuterViewSource.getValue();
    };

    //# set value to buffer zone filter
    setBuffZoneFilter = (val: string): void =>{
        this.bufferZoneFilterSource.next(val);
        this.bufferZoneFilterSource.next(null);
    };

    //# set value to good info storage
    setGoodInfo = (val: InfoPanelGUID): void =>{
        this.goodInfoStorageSource.next(val);
    };

    //# set value to good info storage
    getGoodInfo = (): InfoPanelGUID =>{
        return this.goodInfoStorageSource.getValue();
    };




    // setUpdateMenuPopperData = (popperName: string): void =>{
    //     this.updateColumnsSource.next(popperName);
    // };


}



// WEBPACK FOOTER //
// ./src/app/stocks/services/stocks-filter.service.ts